import { useQuery } from '@tanstack/react-query';
import { expertProfileApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertProfileFilters } from '../types/expert-profile';

export function useExpertProfiles(filters: Partial<ExpertProfileFilters>) {
  return useQuery({
    queryKey: queryKeys.expertProfiles.list(filters),
    queryFn: () => expertProfileApi.listExpertProfiles(filters),
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}

export function useActiveExpertProfiles() {
  return useQuery({
    queryKey: queryKeys.expertProfiles.active(),
    queryFn: async () => {
      const response = await expertProfileApi.getActiveProfiles();
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
